export interface CountdownInfoProps {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export const getCountdownInfo = (nextDropDate: Date): CountdownInfoProps => {
  const total = nextDropDate.getTime() - new Date().getTime();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

export const formatCountdownString = (
  countdownInfo: CountdownInfoProps,
): string => {
  const {days, hours, minutes} = countdownInfo;
  const formattedDays = `${days} day${days !== 1 ? 's' : ''}`;
  const formattedHours = `${hours} hour${hours !== 1 ? 's' : ''}`;
  const formattedMinutes = `${minutes} minute${minutes !== 1 ? 's' : ''}`;

  return `Next drop in: ${formattedDays} ${formattedHours} ${formattedMinutes}`;
};
